module.exports = __webpack_public_path__ + "static/media/computer.fa6fc157.png";